import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import EventLogIndexPage from '../containers/EventLogs'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const EventLogsPage = ({
  location,
	match
}) => {
  const dispatch = useDispatch()
	const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
	const { pathname } = location

	useEffect(() => {
		if (current[0] !== 'event_logs') {
			dispatch(changeCurrent(['event_logs']))
		}
	}, [pathname])

	const path = match.url

  return (
		<Switch>
			<Route path={`${path}/`} component={EventLogIndexPage} exact />
		</Switch>
  )
}

EventLogsPage.propTypes = {
  location: PropTypes.object.isRequired,
	match: PropTypes.object.isRequired
}

EventLogsPage.defaultProps = {}

export default EventLogsPage
